import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AuthNgrx} from '~model/ngrx/auth-ngrx';

export const featureKeyAuth = 'auth';
export const selectFeature = createFeatureSelector<AuthNgrx>(featureKeyAuth);

export const getAuth = createSelector(selectFeature, (state) => state);
